/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconArrowDownBig8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDownBig8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="m1.959 4.491 1.77 1.673V.604h.667v5.56l1.772-1.673.457.485-2.562 2.42-2.562-2.42.458-.485Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowDownBig12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDownBig12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="m2.938 6.737 2.656 2.51V.905h1v8.34l2.657-2.509.687.727-3.844 3.63-3.843-3.63.687-.727Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowDownBig16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDownBig16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="m3.916 8.983 3.543 3.345V1.209h1.333v11.12l3.542-3.345.916.97-5.125 4.839-5.124-4.84.915-.97Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowDownBig20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDownBig20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="m4.896 11.228 4.428 4.183V1.51h1.667v13.9l4.428-4.182 1.144 1.212-6.406 6.05-6.405-6.05 1.144-1.212Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowDownBig24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDownBig24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m5.875 13.474 5.313 5.019V1.812h2v16.68l5.314-5.018 1.373 1.454-7.687 7.26-7.686-7.26 1.373-1.454Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconArrowDownBig = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDownBig(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconArrowDownBig8 {...iconProps} />;
        case '12':
            return <IconArrowDownBig12 {...iconProps} />;
        case '16':
            return <IconArrowDownBig16 {...iconProps} />;
        case '20':
            return <IconArrowDownBig20 {...iconProps} />;
        case '24':
            return <IconArrowDownBig24 {...iconProps} />;
        default:
            return <IconArrowDownBig24 {...iconProps} />;
    }
});
